import Section12 from '../RoutePage/SectionManager/Section12';
import Section3 from '../RoutePage/SectionManager/Section3';
import Section4 from '../RoutePage/SectionManager/Section4';
import Section8 from '../RoutePage/SectionManager/Section8';
import Section9 from '../RoutePage/SectionManager/Section9';
import SectionCheckPrice from './SectionManager/SectionCheckPrice';
import SectionCompareAirline from './SectionManager/SectionCompareAirline';
import SectionFamousRoute from './SectionManager/SectionFamousRoute';
import SectionFamousRouteDesktop from './SectionManager/SectionFamousRoute/desktop';
import SectionFamousToRoute from './SectionManager/SectionFamousToRoute';
import SectionFamousToRouteDesktop from './SectionManager/SectionFamousToRoute/desktop';
import SectionFindCheepTicket from './SectionManager/SectionFindCheepTicket';
import SectionOtherCompany from './SectionManager/SectionOtherCompany';
import SectionPartner from './SectionManager/SectionPartner';
import SectionPartnerDesktop from './SectionManager/SectionPartner/desktop';
import SectionWhyBookUs from './SectionManager/SectionWhyBookUs';
import SectionWhyBookUsDesktop from './SectionManager/SectionWhyBookUs/desktop';

/* eslint-disable no-irregular-whitespace */
export const MENU_BAR = [
  { label: 'Tìm chuyến' },
  { label: 'Săn vé' },
  { label: 'Vé Tết' },
  { label: 'Thông tin' },
  // { label: 'Di chuyển' },
];

export const CONTENT_SECTION = ({ isDesktop }: { isDesktop?: boolean }) => ({
  section1: {
    isNewYear: false,
    alignCenter: isDesktop,
    isHaveDivider: true,
    id: 'san-ve',
    title: {
      vi: 'Săn khuyến mãi vé máy bay {{company}} {{route_name}}',
      component: 'h2',
    },
    title2: {
      vi: 'Săn vé máy bay giá rẻ {{company}} {{route_name}}',
    },
    note: {
      vi: 'Giá trên Goyolo.com đã bao gồm thuế, phí cho 1 người lớn',
    },
    note2: {
      vi: 'Thời gian khởi hành theo giờ địa phương',
    },
    description: {
      vi: 'Bấm vào ngày để xem ngay các giờ bay của {{company}} có giá cực rẻ {{route_name}}',
    },
    component: SectionFindCheepTicket,
  },
  section2: {
    isNewYear: false,
    alignCenter: isDesktop,
    isHaveDivider: false,
    id: 'san-ve',
    title: {
      vi: 'Check giờ bay và giá vé rẻ nhất của {{company}} tuyến {{route_name}} 7 ngày tới từ hôm nay',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: 'Bấm vào để đặt ngay chuyến có giờ bay rẻ nhất trong tuần. Số lượng ghế có giá cực rẻ này sẽ hết rất nhanh. ',
    },
    component: SectionCheckPrice,
  },
  section3: {
    isNewYear: false,
    alignCenter: isDesktop,
    isHaveDivider: false,
    id: 'san-ve',
    title: {
      vi: 'Xem chặng bay của {{company}} {{route_name}} có giá rẻ nhất trong 30 ngày tới',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: 'Bấm vào ngày để xem ngay giờ khởi hành, tiện ích, hãng bay có giá tốt nhất đi {{to_name}}',
    },
    component: Section3,
  },
  section4: {
    isNewYear: false,
    alignCenter: isDesktop,
    isHaveDivider: false,
    id: 'san-ve',
    title: {
      vi: 'Thống kê Top 3 ngày có giá vé {{company}} {{route_name}} thấp nhất trong 30 ngày tới',
      component: 'h3',
    },
    note: {
      vi: 'Giá trên Goyolo.com đã bao gồm thuế, phí cho 1 người lớn',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: 'Bấm vào mỗi ngày để xem giờ bay và những chuyến có giá thấp nhất giữa các hãng hàng không cùng chặng hành trình này',
    },
    component: Section4,
  },
  section5: {
    isNewYear: false,
    alignCenter: isDesktop,
    isHaveDivider: false,
    id: 'san-ve',
    title: {
      vi: 'So sánh giá vé máy bay {{route_hyphen_name}} rẻ nhất giữa {{company}} và các hãng bay khác',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: `Bạn có thể xem giá vé thấp nhất mỗi ngày trong 1 tuần tới trên lịch. Còn mỗi hàng thể hiện giá vé thấp nhất đã bao gồm thuế phí của từng hãng bay trong ngày đó để bạn lựa chọn được hãng bay phù hợp với tình hình tài chính của mình. <br/>
      <br/>
      Bấm vào nút “Đặt vé" để đặt mua ngay vé máy bay của hãng mà bạn thích nhất`,
    },
    component: SectionCompareAirline,
  },
  section6: {
    isNewYear: false,
    id: 'san-ve',
    title: {
      vi: 'Mẹo săn vé máy bay {{company}} giá rẻ {{route_name}}',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: `
      Thời điểm Covid thì bạn có thể mua vé gần ngày đi vì giá vẫn thấp. Nhu cầu đi lại của mọi người vẫn chưa cao nên tỉ lệ lấp đầy của hãng {{company}} cũng không cao dẫn đến giá sẽ không cao như các năm trước. Tuy nhiên thị trường đang dần hồi phục nên các đợt cao điểm như Lễ, Tết thì giá vẫn rất cao vì cung không đủ cầu. <br/>
      <br/> 
      Mẹo để săn vé rẻ nhất là bạn nên book vé sớm trước vài tuần bằng cách xem lịch ở trang chủ của Goyolo.com. Chúng tôi liệt kê sẵn giá tất cả các ngày trong tháng với những ngày nào giá thấp nhất giữa tất cả các hãng bay được tô đậm như hình bên trên. Bạn chọn ngày nào có giá tốt nhất và phù hợp lịch di chuyển của bạn.`,
    },
    component: null,
  },

  section8: {
    isNewYear: true,
    isHaveDivider: true,
    alignCenter: isDesktop,
    id: 've-tet',
    title: {
      vi: 'Vé máy bay giá rẻ Tết {{luna_year}} {{route_name}} của {{company}}',
      component: 'h2',
    },
    title2: {
      vi: 'Bảng giá vé máy bay Tết {{luna_year}} giá rẻ nhất của {{company}}',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: [
        'Giá vé trên là giá vé 1 chiều, dành cho 1 hành khách ở hạng ghế phổ thông.',
        'Giá vé trên đã bao gồm thuế và các khoản phụ phí khác.',
        'Giá vé có thể thay đổi tùy thuộc vào thời gian đặt vé và hạng ghế được chọn. ',
      ],
    },
    description: {
      vi: `
      {{company}} đã mở bán vé máy bay Tết {{luna_year}} {{route_name}} với mức giá cực hấp dẫn`,
    },
    component: Section8,
  },
  section9: {
    isNewYear: true,
    alignCenter: isDesktop,
    id: 've-tet',
    title: {
      vi: 'Giá vé máy bay Tết {{luna_year}} rẻ nhất {{route_name}} của {{company}} cập nhật {{route_now}}',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: 'Giá trên Goyolo.com đã bao gồm thuế, phí cho 1 người lớn',
    },
    description: {
      vi: `
      Giá vé máy bay Tết {{luna_year}} của {{company}} được cập nhật liên tục trên Goyolo.com để giúp cho hành khách có những tấm vé máy bay Tết {{route_name}} giá rẻ nhất. Ngay từ {{route_now}}, hãng hàng không nội địa {{route_airline}} đã mở bán vé máy bay Tết {{luna_year}}. Hãy cùng Goyolo.com theo dõi bảng giá vé các tháng Tết {{luna_year}} để đặt vé sớm. <br/> <br/>
      
      Nhấn vào ngày bất kỳ để xem giờ có giá tốt nhất trong ngày đó`,
    },
    component: Section9,
  },
  section10: {
    id: 've-tet',
    isHaveDivider: false,
    alignCenter: isDesktop,
    title: {
      vi: 'Thời điểm săn vé máy bay {{company}} {{route_name}} Tết {{luna_year}}',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: `
      Khi có lịch nghỉ Tết Ta {{luna_year}}, bạn nên tiến hành book ngay vé máy bay Tết đi {{to_name}} của {{company}}. Bí kíp là bạn cũng có thể đặt vé trước vài tháng vì mua vé càng sớm, bạn sẽ dễ dàng lựa chọn được ngày giờ bay ưng ý với mức giá khuyến mãi rẻ nhất. Tìm vé càng cận Tết sẽ dễ rơi vào tình huống cháy vé hoặc phải mua vé với giá cao ngất ngưỡng. Vậy việc booking vé Tết càng sớm luôn có lợi hơn cả.`,
    },
    component: null,
  },
  section11: {
    id: 've-tet',
    alignCenter: isDesktop,
    title: {
      vi: 'Lịch bán vé máy bay Tết {{luna_year}} {{route_name}}',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: `
      Hãng hàng không {{company}} sẽ mở bán vé Tết chặng {{route_name}} trong 3 đợt. Đợt bán vé đầu tiên thường bắt đầu tầm giữa tháng 9 và tháng 10, đợt 2 tầm tháng 10 và tháng 11, đợt còn lại cho đến Tết. Thường thì vé được bán trong đợt 1 có giá rẻ nhất với số lượng nhiều nhất, càng về gần Tết vé máy bay càng ít dần và giá càng bị đẩy lên cao theo cơ chế cung cầu. Do đó, thời điểm săn mua vé máy bay Tết {{luna_year}} tốt hơn hết bạn nên mua vé ngay khi hãng mở bán trong đợt đầu tiên để có thể chắc chắn mình mua được vé với giá tốt nhất.`,
    },
    component: null,
  },
  section12: {
    id: 'thong-tin',
    alignCenter: isDesktop,
    isHaveDivider: true,
    title: {
      vi: 'Thông tin chuyến bay {{route_name}} của {{company}}',
      component: 'h2',
    },
    title2: {
      vi: 'Thông tin chuyến bay',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: `
      Chặng bay {{route_name}} dài khoảng {{distance}} km. Trung bình mỗi ngày có khoảng {{average_flight_count}} chuyến bay trên Goyolo.com, chuyến sớm nhất cất cánh lúc {{earliest_pickup_time}}, chuyến bay trễ nhất {{route_name}} cất cánh vào lúc {{latest_pickup_time}}, được vận hành bởi hãng máy bay {{route_airline}}. Giá vé máy bay rẻ nhất hôm nay là {{min_fare}}, tuần này là {{min_7_days_fare}}, 30 ngày kế tiếp là {{min_30_days_fare}}. Mất khoảng {{average_duration}} phút để hoàn thành chuyến bay {{route_name}}.`,
    },
    description: {
      vi: `
      Xem các thông tin về thời gian bay, tổng chiều dài đường bay, sân bay, lịch bay {{route_name}}.`,
    },
    component: Section12,
  },
  SectionParner: {
    id: 'thong-tin',
    isHaveDivider: true,
    title: {
      vi: 'Hơn 1500+ đối tác của Goyolo.com',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: '',
    },
    component: isDesktop ? SectionPartnerDesktop : SectionPartner,
  },
  SectionOtherCompany: {
    id: 'thong-tin',
    isHaveDivider: true,
    title: {
      vi: 'Vé máy bay {{route_name}} của các hãng hàng không khác',
      component: 'h2',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: '',
    },
    component: SectionOtherCompany,
  },
  SectionFamousFromRoute: {
    id: 'thong-tin',
    isHaveDivider: true,
    title: {
      vi: 'Các chặng bay phổ biến từ {{from_name}}',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: '',
    },
    component: isDesktop ? SectionFamousRouteDesktop : SectionFamousRoute,
  },
  SectionFamousToRoute: {
    id: 'thong-tin',
    isHaveDivider: true,
    title: {
      vi: 'Các chặng bay phổ biến từ {{to_name}}',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: '',
    },
    component: isDesktop ? SectionFamousToRouteDesktop : SectionFamousToRoute,
  },
  SectionWhyBookUs: {
    id: 'thong-tin',
    isHaveDivider: true,
    title: {
      vi: 'Tại sao bạn nên đặt vé qua Goyolo.com',
      component: 'h3',
    },
    note: {
      vi: '',
    },
    note2: {
      vi: '',
    },
    description: {
      vi: '',
    },
    component: isDesktop ? SectionWhyBookUsDesktop : SectionWhyBookUs,
  },
});

export const metaFaqJson = `
{
  "@context": "https://schema.org",
  "@type": "QAPage",
  "mainEntity": [{
    "@type": "Question",
    "name": "Giá vé máy bay {{company}} ngày hôm nay {{route_name}}",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Hiện tại giá vé {{company}} đi {{to_name}} thấp nhất là từ {{min_fare}}, khởi hành lúc {{min_price_time}} giờ."
    }
  },{
    "@type": "Question",
    "name": "Chuyến bay {{route_name}} của {{company}} khởi hành sớm nhất hôm nay?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Hiện tại Goyolo.com ghi nhận chuyến bay {{route_name}} được vận hành bởi {{company}} có khởi hành sớm nhất là lúc {{earliest_pickup_time}} giờ."
    }
  },{
    "@type": "Question",
    "name": "Chuyến bay {{route_name}} của {{company}} được vận hành bởi {{company}} khởi hành trễ nhất hôm nay?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Hiện tại Goyolo.com ghi nhận chuyến bay {{route_name}} được vận hành bởi {{company}} có khởi hành trễ nhất là lúc {{latest_pickup_time}} giờ."
    }
  },{
    "@type": "Question",
    "name": "Tôi có thể tìm vé máy bay của {{company}} {{route_name}} khuyến mãi như thế nào?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Bạn có thể tìm kiếm chương trình khuyến mãi tại mục 'Mẹo săn vé máy bay giá rẻ {{route_name}}' hoặc lựa chọn nhận thông tin khuyến mãi qua thông báo website và email để không bỏ lỡ các chương trình săn vé giá rẻ của Goyolo.com."
    }
  },{
    "@type": "Question",
    "name": "Tôi có thể mua vé máy bay {{company}} đi {{to_name}} 247 qua Goyolo.com được không?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Chúng tôi hoạt động tất cả các ngày kể cả thứ 7, chủ nhật và ngày Lễ, Tết bạn có thể đặt vé bất cứ khi nào có nhu cầu."
    }
  },{
    "@type": "Question",
    "name": "Trẻ em và trẻ sơ sinh đi máy bay cần những giấy tờ gì?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Đối với trẻ em khi đi máy bay đều sẽ cần có giấy khai sinh bản chính hoặc công chứng, ngoài ra hãng còn yêu cầu trẻ em phải có đủ sức khỏe để được tham gia chuyến bay. Sẽ có một tiếp viên hàng không hoặc người thân trên 18 tuổi đi cùng bé, trẻ em sẽ được sử dụng các dịch vụ trên chuyến bay trong vòng 24 giờ. Với trường hợp trẻ sơ sinh đi máy bay thì sẽ bắt buộc cần giấy khai sinh để làm mọi thủ tục liên quan trước khi cất cánh và đặc biệt sẽ có phụ huynh theo kèm bé."
    }
  },{
    "@type": "Question",
    "name": "Goyolo.com có bán vé máy bay {{company}} Tết đi {{to_name}} năm nay không?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Goyolo.com có mở bán vé máy bay Tết của {{company}} và cả Vé xe khách của các thương hiệu uy tín {{route_name}}, với mức giá ưu đãi nhất."
    }
  },{
    "@type": "Question",
    "name": "{{company}} quy định an toàn Covid-19 như thế nào khi bay?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Khi đi máy bay {{company}}, hành khách phải tuân thủ các quy định sau để đảm bảo an toàn Covid-19: Thực hiện khai báo y tế trên ứng dụng PC-COVID (Theo công văn số 1887/BGTVT-CYT của Bộ Giao thông Vận tải ngày 28/10/2021). Không được tham gia chuyến bay khi có các triệu chứng ho, sốt, khó thở, đau mỏi cơ, đau rát họng, mất vị giác,…
      Luôn đeo khẩu trang, sát khuẩn tay, hạn chế tiếp xúc trước, trong và sau chuyến bay. Trong quá trình di chuyển từ Cảng hàng không về nơi cư trú luôn thực hiện 5K, hạn chế dừng và không tiếp xúc nơi đông người. Chủ động thông báo với chính quyền địa phương nơi cư trú, lưu trú. Tự theo dõi sức khoẻ và thực hiện theo quy định cụ thể của từng địa phương về các biện pháp phòng chống dịch COVID-19 kể từ ngày về địa phương. Trường hợp có dấu hiệu bất thường về sức khoẻ như ho, sốt, khó thở, đau rát họng, mất vị giác…thông báo ngay cho cơ quan y tế để theo dõi và triển khai quy trình xử lý dịch bệnh theo quy định."
    }
  },{
    "@type": "Question",
    "name": "Tôi mua vé máy bay {{company}} thì có được hoàn huỷ không?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Chính sách và phí hoàn hủy vé của hãng hàng không {{company}} thay đổi tuỳ thuộc vào hạng ghế và thời gian khởi hành của vé. Hạng vé và giá vé càng thấp thì thường sẽ không có chính sách hoàn vé hay huỷ vé. Theo kinh nghiệm hoàn huỷ vé máy bay, trong các đợt Tết, quy định hoàn huỷ vé thường sẽ thay đổi. Nếu bạn huỷ vé càng sớm, chính sách huỷ sẽ càng tốt và số tiền bạn được hoàn lại sẽ cao. Lưu ý, trong một số trường hợp, bạn không thể hoàn huỷ vé ngay sát giờ khởi hành. Đối với các trường hợp hoàn huỷ vé vì lý do bất khả kháng hoặc liên quan đến dịch bệnh Covid-19, hãng sẽ có các chính sách hoàn huỷ vé tạo điều kiện hỗ trợ tối đa cho hành khách. Để biết chính sách cụ thể về điều kiện huỷ của {{company}}, bạn vui lòng tham khảo tại mục 'Chính sách và phí hoàn hủy vé'"
    }
  },{
    "@type": "Question",
    "name": "Tôi có được đổi ngày giờ bay khi đặt vé máy bay {{company}} không?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": " Chính sách và phí đổi giờ bay, ngày bay của hãng hàng không {{company}} thay đổi tuỳ thuộc vào hạng ghế và thời gian khởi hành của vé. Hạng vé và giá vé càng thấp thì thường sẽ không có chính sách thay đổi ngày giờ bay. Theo kinh nghiệm đổi vé máy bay, trong các đợt Tết, quy định đổi vé thường sẽ thay đổi. Nếu bạn đổi chuyến bay càng sớm, chính sách đổi sẽ càng tốt. Lưu ý, trong một số trường hợp, bạn không thể đổi vé ngay sát giờ khởi hành. Đối với các trường hợp đổi ngày giờ bay vì lý do bất khả kháng hoặc liên quan đến dịch bệnh Covid-19, hãng sẽ có các chính sách đổi vé tạo điều kiện hỗ trợ tối đa cho hành khách. Để biết chính sách cụ thể về điều kiện đổi chuyến bay của {{company}}, bạn vui lòng tham khảo tại mục 'Chính sách và phí đổi ngày, giờ bay'"
    }
  }]
}
`;

export const FAQ = [
  {
    id: 1,
    title: 'Giá vé máy bay {{company}} ngày hôm nay {{route_name}}',
    content: 'Hiện tại giá vé {{company}} đi {{to_name}} thấp nhất là từ {{min_fare}}, khởi hành lúc {{min_price_time}} giờ.',
    onClick: '',
  },
  {
    id: 2,
    title: 'Chuyến bay {{route_name}} của {{company}} khởi hành sớm nhất hôm nay?',
    content: 'Hiện tại Goyolo.com ghi nhận chuyến bay {{route_name}} được vận hành bởi {{company}} có khởi hành sớm nhất là lúc {{earliest_pickup_time}} giờ.',
    onClick: '',
  },
  {
    id: 3,
    title: 'Chuyến bay {{route_name}} của {{company}} khởi hành trễ nhất hôm nay?',
    content: 'Hiện tại Goyolo.com ghi nhận chuyến bay {{route_name}} được vận hành bởi {{company}} có khởi hành trễ nhất là lúc {{latest_pickup_time}} giờ.',
    onClick: '',
  },
  {
    id: 4,
    title: 'Tôi có thể tìm vé máy bay của {{company}} {{route_name}} khuyến mãi như thế nào?',
    content: 'Bạn có thể tìm kiếm chương trình khuyến mãi tại mục "Mẹo săn vé máy bay giá rẻ {{route_name}}" hoặc lựa chọn nhận thông tin khuyến mãi qua thông báo website và email để không bỏ lỡ các chương trình săn vé giá rẻ của Goyolo.com.',
    onClick: '',
  },
  {
    id: 5,
    title: 'Tôi có thể mua vé máy bay {{company}} đi {{to_name}} 247 qua Goyolo.com được không?',
    content: 'Chúng tôi hoạt động tất cả các ngày kể cả thứ 7, chủ nhật và ngày Lễ, Tết bạn có thể đặt vé bất cứ khi nào có nhu cầu.',
    onClick: '',
  },
  {
    id: 6,
    title: 'Trẻ em và trẻ sơ sinh đi máy bay cần những giấy tờ gì?',
    content: `Đối với trẻ em khi đi máy bay đều sẽ cần có giấy khai sinh bản chính hoặc công chứng, ngoài ra hãng còn yêu cầu trẻ em phải có đủ sức khỏe để được tham gia chuyến bay. Sẽ có một tiếp viên hàng không hoặc người thân trên 18 tuổi đi cùng bé, trẻ em sẽ được sử dụng các dịch vụ trên chuyến bay trong vòng 24 giờ.
    <br/>
    <br/>
    Với trường hợp trẻ sơ sinh đi máy bay thì sẽ bắt buộc cần giấy khai sinh để làm mọi thủ tục liên quan trước khi cất cánh và đặc biệt sẽ có phụ huynh theo kèm bé.
    
    `,
    onClick: '',
  },
  {
    id: 6,
    title: 'Goyolo.com có bán vé máy bay {{company}} Tết đi {{to_name}} năm nay không?',
    content: 'Goyolo.com có mở bán vé máy bay Tết của {{company}} và cả Vé xe khách của các thương hiệu uy tín {{route_name}}, với mức giá ưu đãi nhất.',
    onClick: '',
  },
  {
    id: 7,
    title: '{{company}} quy định an toàn Covid-19 như thế nào khi bay?',
    content: `<p>Khi đi máy bay {{company}}, hành khách phải tuân thủ các quy định sau để đảm bảo an toàn Covid-19:</p>
    <ul>
       <li><span>Thực hiện khai báo y tế trên ứng dụng PC-COVID (Theo công văn số 1887/BGTVT-CYT của Bộ Giao thông Vận tải ngày 28/10/2021)</span></li>
       <li><span>Không được tham gia chuyến bay khi có các triệu chứng ho, sốt, khó thở, đau mỏi cơ, đau rát họng, mất vị giác,…</span></li>
       <li><span>Luôn đeo khẩu trang, sát khuẩn tay, hạn chế tiếp xúc trước, trong và sau chuyến bay</span></li>
       <li><span>Trong quá trình di chuyển từ Cảng hàng không về nơi cư trú luôn thực hiện 5K, hạn chế dừng và không tiếp xúc nơi đông người</span></li>
       <li><span>Chủ động thông báo với chính quyền địa phương nơi cư trú, lưu trú</span></li>
       <li><span>Tự theo dõi sức khoẻ và thực hiện theo quy định cụ thể của từng địa phương về các biện pháp phòng chống dịch COVID-19 kể từ ngày về địa phương</span></li>
       <li><span>Trường hợp có dấu hiệu bất thường về sức khoẻ như ho, sốt, khó thở, đau rát họng, mất vị giác…thông báo ngay cho cơ quan y tế để theo dõi và triển khai quy trình xử lý dịch bệnh theo quy định.</span></li>
    </ul>
    
    `,
    onClick: '',
  },
  {
    id: 8,
    title: 'Tôi mua vé máy bay {{company}} thì có được hoàn huỷ không?',
    content: `
    Chính sách và phí hoàn hủy vé của hãng hàng không {{company}} thay đổi tuỳ thuộc vào hạng ghế và thời gian khởi hành của vé. Hạng vé và giá vé càng thấp thì thường sẽ không có chính sách hoàn vé hay huỷ vé. Theo kinh nghiệm hoàn huỷ vé máy bay, trong các đợt Tết, quy định hoàn huỷ vé thường sẽ thay đổi. Nếu bạn huỷ vé càng sớm, chính sách huỷ sẽ càng tốt và số tiền bạn được hoàn lại sẽ cao. Lưu ý, trong một số trường hợp, bạn không thể hoàn huỷ vé ngay sát giờ khởi hành
    <br/>
    Đối với các trường hợp hoàn huỷ vé vì lý do bất khả kháng hoặc liên quan đến dịch bệnh Covid-19, hãng sẽ có các chính sách hoàn huỷ vé tạo điều kiện hỗ trợ tối đa cho hành khách.
Để biết chính sách cụ thể về điều kiện huỷ của {{company}}, bạn vui lòng tham khảo tại mục "Chính sách và phí hoàn hủy vé"

    `,
    onClick: '',
  },
  {
    id: 9,
    title: 'Tôi có được đổi ngày giờ bay khi đặt vé máy bay {{company}} không?',
    content: `
    Chính sách và phí đổi giờ bay, ngày bay của hãng hàng không {{company}} thay đổi tuỳ thuộc vào hạng ghế và thời gian khởi hành của vé. Hạng vé và giá vé càng thấp thì thường sẽ không có chính sách thay đổi ngày giờ bay. Theo kinh nghiệm đổi vé máy bay, trong các đợt Tết, quy định đổi vé thường sẽ thay đổi. Nếu bạn đổi chuyến bay càng sớm, chính sách đổi sẽ càng tốt. Lưu ý, trong một số trường hợp, bạn không thể đổi vé ngay sát giờ khởi hành.
    <br/>
    Đối với các trường hợp đổi ngày giờ bay vì lý do bất khả kháng hoặc liên quan đến dịch bệnh Covid-19, hãng sẽ có các chính sách đổi vé tạo điều kiện hỗ trợ tối đa cho hành khách.
  Để biết chính sách cụ thể về điều kiện đổi chuyến bay của {{company}}, bạn vui lòng tham khảo tại mục "Chính sách và phí đổi ngày, giờ bay"
    `,
    onClick: '',
  },
];
